export default {
  init(instance) {
    document.addEventListener('alpine:init', () => {
      instance.data('TabGroupComponent', (tabGroup, label = '') => {
        return {
          activeTab: 0,
          tabs: tabGroup,
          tabItems: tabGroup[0].tab_items,
          group: tabGroup[0],
          label,
          ctaLabel: label + ' ' + tabGroup[0].label,
          nextTab() {
            if (this.activeTab === this.tabs.length - 1) {
              this.activeTab = 0;
            } else {
              this.activeTab++;
            }
          },
          prevTab() {
            if (this.activeTab === 0) {
              this.activeTab = this.tabs.length - 1;
            } else {
              this.activeTab--;
            }
          },
          getActiveTabKey() {
            return (
              ['filingTime', 'expeditedTime', 'expeditedPrice'][
                this.activeTab
              ] || 'filingTime'
            );
          },
          setActiveTab(tab, index) {
            this.activeTab = index;
            this.tabItems = tab.tab_items;
            this.group = this.tabs[index];
            this.ctaLabel = label + ' ' + this.group.label;
          },
        };
      });
    });
  },
};
